var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{class:{flixFocus: _vm.focus},attrs:{"for":_vm.data.id},domProps:{"innerHTML":_vm._s(_vm.data.label)}}),(_vm.data.required)?_c('span',{staticClass:"labelRequired"},[_vm._v("  "),(!_vm.focus)?_c('span',[_vm._v("*")]):_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('message.isRequired')))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }